import environment from '@root/core/src/utils/environment';

export default function useAgentSchedule({ date = new Date() } = {}) {
  const operatingDaysOff = environment.agentsISAOperatingDaysOff;
  const operatingHoursEnd = environment.agentsISAOperatingHoursEnd;
  const operatingHoursStart = environment.agentsISAOperatingHoursStart;

  const hours = parseInt(date.toLocaleString('en-US', {
    hour: '2-digit',
    hour12: false,
    timeZone: 'America/New_York',
  }));

  const dayOfTheWeek = date.toLocaleString('en-US', {
    weekday: 'short',
    timeZone: 'America/New_York',
  });

  const isDuringBusinessHours = !(hours < operatingHoursStart || hours > operatingHoursEnd || operatingDaysOff.includes(dayOfTheWeek));

  return {
    isDuringBusinessHours,
    operatingHoursStart,
    operatingHoursEnd,
  };
}
